import { SERVICE_PROVISION, VISITOR_STATISTICS } from '@/components/consent-management/cookie-consent/cookie-options'
import { AUTHENTICATION, MATOMO } from '@/model/flags'

export default {
    title: 'Cookie settings',
    intro: 'Manage your cookie settings here. You can change your settings again at any time. To learn more, please read our privacy policy.',
    showDataProctection: 'Show privacy policy',
    button: {
        acceptSelection: 'Accept selected',
        selectAll: 'Enable all',
        unselectAll: 'Disable all'
    },
    [SERVICE_PROVISION]: {
        title: 'Service Provision',
        services: {
            [AUTHENTICATION]: {
                name: 'Authentication Cookie',
                description: 'We use authentication cookies to ensure secure access to our online service.'
            }
        }
    },
    [VISITOR_STATISTICS]: {
        title: 'Visitor statistics',
        services: {
            [MATOMO]: {
                name: 'Matomo',
                description: 'We use Matomo to collect visitor statistics.'
            }
        }
    },
    required: '[always required]',
    purpose: 'purpose'
}
